import React, {useContext} from 'react'

const TerminosCondiciones = () => {
  return (
    <div className="container">
      <div id="primary" className="content-area">
        <main id="main" className="site-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h4>TÉRMINOS Y CONDICIONES AEROMALL EL SALVADOR</h4>
                <p>
                  Los términos y condiciones que se detallan a continuación son
                  aplicables a todos los servicios que se ofrecen en el sitio
                  web www.aeromall.com.sv, en adelante denominado “AEROMALL”,
                  perteneciente a la sociedad denominada SERVICIO SALVADOREÑO DE
                  PROTECCIÓN, SOCIEDAD ANÓNIMA DE CAPITAL VARIABLE, que se
                  abrevia SERVICIO SALVADOREÑO DE PROTECCIÓN, S.A. DE C.V., y
                  también SERSAPRO, S.A. DE C.V.
                </p>
              </div>

              <div className="col-md-12">
                <p>
                  <b>
                    POR FAVOR LEA DETENIDAMENTE LOS SIGUIENTES TÉRMINOS Y
                    CONDICIONES ANTES DE ACCEDER O UTILIZAR LOS SERVICIOS, CON
                    EL PROPÓSITO DE ASEGURARSE DE QUE USTED ENTIENDE CADA
                    DISPOSICIÓN.
                  </b>
                </p>
                <p>
                  Queda facultado el Usuario que la visite, en adelante
                  denominado “el Usuario”, a utilizar la plataforma electrónica
                  para adquirir, si lo desea, los diferentes productos que se
                  ofertan por parte de AEROMALL o por parte de cualquier
                  Comercio Afiliado a AEROMALL; pudiendo el Usuario, si
                  quisiera, registrarse previamente a través del “Formulario de
                  Registro de Usuario” que se encuentra en el sitio web
                  AEROMALL, o simplemente ingresar sin necesidad de registrarse.
                  En el caso de productos ofrecidos por un Comercio Afiliado a
                  AEROMALL, el Usuario entiende y acepta que AEROMALL es
                  únicamente un mero intermediario entre dicho Comercio Afiliado
                  y el Usuario; por lo que AEROMALL no asume ninguna
                  responsabilidad con respecto a la calidad, características y
                  garantías de dichos productos. En esos casos, cualquier
                  reclamo relativo a las razones antes dichas, deberá ser hecho
                  directamente por el Usuario al Comercio Afiliado, de
                  conformidad a lo que se establece más adelante. El Usuario
                  deberá leer y aceptar, previamente a comprar un producto, los
                  siguientes términos y condiciones:
                </p>
              </div>
              <div className="col-md-12">
                <h6>PROPIEDAD INTELECTUAL</h6>
                <p>
                  Todo el contenido que aparece en este sitio web es de
                  propiedad, o de licencia de uso, de AEROMALL o de sus
                  Comercios Afiliados. Esto incluye, pero no se limita a,
                  nombres comerciales, marcas, nombres de dominio, señales de
                  publicidad, logos, diseños gráficos, códigos fuente, audios,
                  textos y cualquier material reflejado en el sitio,
                  encontrándose protegidos por la legislación, nacional e
                  internacional, aplicable a la Protección Intelectual; por lo
                  que los mismos no pueden ser utilizados, copiados,
                  reproducidos, duplicados, publicados o comercializados de
                  forma alguna sin el consentimiento escrito de AEROMALL o de
                  los Comercios Afiliados, bajo pena de incurrir, quien lo
                  hiciere, en responsabilidad civil o penal.
                </p>
              </div>
              <div className="col-md-12">
                <h6>CREACIÓN DE CUENTA</h6>
                <p>
                  Toda persona natural mayor de 18 años, o persona jurídica, que
                  tenga interés en adquirir cualquiera de los productos que se
                  comercializan en este sitio web, podrá realizar su registro
                  previo, de forma gratuita, si así lo desea, a través del
                  “Formulario de Registro de Usuario”, a fin de crear un nombre
                  de Usuario y una Contraseña que lo identifiquen; información
                  que se almacenará en una base de datos para uso comercial o de
                  promoción. Así como por lo menos un método de pago válido
                  (bien una tarjeta de crédito, tarjeta de débito, Paypal o bien
                  un socio de pago aceptado). El Usuario se compromete a
                  mantener la información en su Cuenta de forma exacta, completa
                  y actualizada. Si no mantiene la información de Cuenta de
                  forma exacta, completa y actualizada, incluso el tener un
                  método de pago inválido o que haya vencido, podrá resultar en
                  su imposibilidad para acceder y utilizar los Servicios o en la
                  resolución por parte de Aeromall de estos Términos y
                  Condiciones. Usted es responsable de toda la actividad que
                  ocurre en su Cuenta y se compromete a mantener en todo momento
                  de forma segura y secreta el nombre de usuario y la contraseña
                  de su Cuenta. A menos que Aeromall permita otra cosa por
                  escrito, usted solo puede poseer una Cuenta.
                  <br />
                  <br />
                  El uso que se le dé al Usuario y a la Contraseña creados será
                  de responsabilidad exclusiva de la persona natural o jurídica.
                  AEROMALL no asume ninguna responsabilidad por el mal uso que
                  se haga de los mismos. Por parte de AEROMALL, existirá el
                  compromiso de no compartir ni utilizar la información
                  ingresada al momento de crear la cuenta, solo para usos de
                  identificación dentro de la plataforma.
                </p>
              </div>
              <div className="col-md-12">
                <h6>COMPRAS Y PAGOS.</h6>
                <p>
                  Todos los productos comercializados en el sitio web AEROMALL
                  podrán ser pagados a través de diferentes métodos de pago, los
                  cuales se detallan a continuación: 1. Pago en línea por medio
                  de tarjeta de crédito o debido, nacional o internacional, de
                  las marcas Visa o MasterCard y 2. Pago contra entrega.
                  <br />
                  <br />
                  Las compras y pagos podrán realizarse durante las veinticuatro
                  horas, los siete días de la semana, salvo fallas tecnológicas
                  imprevistas, las cuales serán resueltas en el menor tiempo
                  posible.
                  <br />
                  <br />
                  Al adquirir un producto, el Usuario deberá pagar el precio IVA
                  incluido y el costo del envío, que dependerá de la zona en
                  donde se realizará la entrega. El detalle del monto total a
                  pagar será mostrado al Usuario previamente a que autorice el
                  pago. Por todos los otros métodos de pago, no existirán cobros
                  por transacción en línea.
                  <br />
                  <br />
                  El costo del envío oscilará entre US$2.99 y US$3.99, IVA
                  incluido. La tarifa dependerá del lugar adonde deba realizarse
                  la entrega del producto. El peso y volumen máximo del paquete
                  a transportar, bajo las tarifas antes indicadas, no deberá
                  sobrepasar las veinticinco (25). Los paquetes que excedan el
                  peso, y que no puedan ser transportados en motocicleta, serán
                  entregados en otros medios de transporte y en esos casos
                  aplicarán otras tarifas distintas a las mencionadas, mismas
                  que serán dadas a conocer al Usuario antes de que autorice su
                  pago. El Usuario podrá recibir hasta un máximo de tres (3)
                  paquetes por un mismo costo de envío, siempre que ambos
                  paquetes en conjunto no excedan el peso o medidas máximos
                  señalados, y que provengan del mismo Comercio y puedan ser
                  entregados al mismo tiempo al Usuario.
                  <br />
                  <br />
                  En caso de inconsistencias, errores o problemas en los cobros
                  realizados, el Usuario deberá hacerlo de inmediato
                  conocimiento de AEROMALL, para que sea solucionado a la
                  brevedad posible.
                  <br />
                  <br />
                  Al realizar su orden de compra, el Usuario deberá señalar si
                  requerirá comprobante de crédito fiscal; de lo contrario, se
                  le enviará tiquete de compra o factura de consumidor final
                  directamente proporcionado por el comercio afiliado del que se
                  compre el producto. El documento de facturación será incluido
                  dentro del paquete conteniendo el producto comprado.
                  <br />
                  <br />
                  AEROMALL ofrece a sus clientes diferentes métodos de pago que
                  quedan a elección del cliente final adaptándonos a las
                  diferentes modalidades.
                  <br />
                  <br />
                  El método de pago modalidad contra entrega no contiene costos
                  adicionales sobre el valor del producto, considerando siempre
                  las tarifas de envío ya establecidas por la zona.
                </p>
              </div>
              <div className="col-md-12">
                <h6>ENTREGA DE LOS BIENES.</h6>
                <p>
                  Una vez aprobada la compra, el Usuario recibirá el producto
                  adquirido en un plazo de 24 a 72 horas, salvo días festivos,
                  días de descanso u horas no hábiles; plazo que dependerá de la
                  distancia que exista entre el Comercio que vende el producto y
                  la dirección de entrega. El servicio de envío será brindado a
                  partir de las 8:30 a.m. hasta las 6:00 p.m., de lunes a
                  viernes; y sábado, de 8:30 a.m. hasta las 6:00 p.m. En los
                  días de asueto exigidos por ley, no se brindará servicio. El
                  plazo de entrega para productos ordenados fuera de estos días
                  y horarios, o en días de asueto, comenzará a correr a partir
                  de las 8:30 a.m. del siguiente día hábil.
                  <br />
                  <br />
                  La entrega del producto adquirido será hecha en la dirección y
                  a la persona que señale el Usuario en su orden de compra, por
                  una empresa de servicio de entrega a domicilio, en adelante
                  denominada “el proveedor”, con la cual AEROMALL tiene una
                  alianza estratégica y que es una entidad independiente a
                  AEROMALL. Si la dirección de entrega del producto adquirido se
                  encuentra dentro de una zona sin cobertura o zona catalogada
                  por el proveedor como de alto riesgo, el Usuario será
                  contactado por el proveedor, por los medios que el Usuario
                  hubiere señalado en su orden de compra, para acordar un punto
                  de entrega.
                  <br />
                  <br />
                  El Usuario podrá ver el estado de su pedido ingresando a su
                  cuenta de AEROMALL; o por medio del correo electrónico que
                  ingresó en su orden compra y con el número de pedido, en caso
                  de no tener una cuenta de AEROMALL. El producto adquirido sólo
                  podrá ser entregado dentro de la República de El Salvador. En
                  caso de que no fuera posible cumplir con el plazo de entrega,
                  por caso fortuito, fuerza mayor, o agotamiento del producto en
                  el inventario del Comercio que lo vende, este último se pondrá
                  en contacto con el Usuario para hacerle saber la razón del
                  retraso y la fecha en que estará recibiendo su producto.
                  <br />
                  <br />
                  El proveedor hará hasta un máximo de dos (2) intentos para
                  entregar el producto, en la dirección señalada por el Usuario,
                  previa comunicación con el Usuario, por los medios de contacto
                  que éste haya establecido en su orden de compra. Luego del
                  segundo intento, sin que se haya podido realizar la entrega
                  por motivos ajenos al proveedor, el producto será devuelto al
                  Comercio que lo vende. En este último caso, no habrá ninguna
                  responsabilidad para AEROMALL, el proveedor o el Comercio
                  Afiliado, no pudiendo reclamar el Usuario ningún reembolso por
                  no haber recibido el producto; y corresponderá al Usuario
                  contactar al Comercio que vende el producto para coordinar la
                  entrega directa.
                  <br />
                  <br />
                  No se brindará servicio de entrega a domicilio para los
                  productos que contengan: títulos valores al portador, joyas,
                  metales preciosos, dinero en efectivo, billetes de lotería,
                  bienes que por su naturaleza sean perecederos, objetos
                  prohibidos, armas o materiales explosivos o inflamables,
                  drogas, materias combustibles peligrosas, animales, y en
                  general cualquier clase de bienes cuyo transporte esté
                  prohibido por disposiciones legales o reglamentarias o por
                  políticas internas del Proveedor.
                  <br />
                  <br />
                  El Usuario deberá recibir su paquete embalado y sellado,
                  conteniendo además el comprobante de facturación solicitado,
                  así como la información de contacto del Comercio que vende el
                  producto. Quien reciba el paquete, en el lugar de entrega,
                  deberá firmar en señal de haberlo recibido, presentando y
                  haciendo constar su número de Documento Único de Identidad
                  (Pasaporte en el caso de extranjeros), así como la hora y
                  fecha de entrega.
                </p>
              </div>
              <div className="col-md-12">
                <h6>MENSAJES DE TEXTO</h6>
                <p>
                  Al crear una Cuenta, el Usuario acepta que AEROMALL le pueda
                  enviar mensajes de texto informativos (SMS) como parte de la
                  actividad comercial normal de su uso de los Servicios. El
                  Usuario podrá solicitar la no recepción de mensajes de texto
                  informativos (SMS) en cualquier momento enviando un correo
                  electrónico a info@aeromall.com.sv o por medio de las líneas
                  telefónicas disponibles en la sección de “Contáctanos” del
                  portal web, señalando que no desea recibir dichos mensajes,
                  junto con el número de teléfono del dispositivo móvil que
                  recibe los mensajes. El Usuario reconoce que solicitar la no
                  recepción de mensajes de texto informativos (SMS) podrá
                  afectar al uso que usted haga de los Servicios.
                </p>
              </div>
              <div className="col-md-12">
                <h6>CÓDIGOS PROMOCIONALES</h6>
                <p>
                  AEROMALL podrá, a su sola discreción, crear códigos
                  promocionales que podrán ser canjeados por crédito de Cuenta u
                  otros elementos o beneficios relacionados con los Servicios
                  y/o los servicios de un Tercero Proveedor, con sujeción a
                  cualquier condición adicional que AEROMALL establezca sobre la
                  base de cada código promocional (“Códigos promocionales”). El
                  Usuario acuerda que los Códigos promocionales: (i) deben
                  usarse para la audiencia y el propósito deseado, y de manera
                  lícita; (ii) no podrán duplicarse, venderse o transferirse de
                  ninguna manera, o ponerse a disposición del público general
                  (tanto si se publican en un foro público como de otra forma),
                  a menos que sea con el permiso de AEROMALL; (iii) podrán ser
                  invalidados por AEROMALL en cualquier momento por cualquier
                  motivo sin responsabilidad para AEROMALL; (iv) podrán usarse
                  solo conforme a las condiciones específicas que AEROMALL
                  establezca para dicho Código promocional; (v) no son válidos
                  como efectivo; y (vi) podrán caducar antes de que los utilice
                  el Usuario. AEROMALL se reserva el derecho de retener o
                  deducir el crédito u otros elementos o beneficios obtenidos a
                  través de la utilización de los Códigos promocionales por el
                  Usuario o cualquier otra persona en el caso de que AEROMALL
                  determine o crea que el uso o el canje de los Códigos
                  promocionales fue de modo erróneo, fraudulento, ilegal o
                  infringiendo las condiciones del Código promocional o las
                  presentes Condiciones.
                </p>
              </div>
              <div className="col-md-12">
                <h6>POLÍTICA DE DEVOLUCIÓN.</h6>
                <p>
                  En caso de que el Usuario no se encuentre satisfecho con el
                  producto adquirido, por causas comprobadas imputables al
                  fabricante o al Comercio que lo vende, deberá contactar
                  directamente a dicho Comercio y regirse bajo las políticas de
                  devolución de éste.
                  <br />
                  <br />
                  En el caso de productos de Comercios Afiliados, AEROMALL es
                  únicamente un intermediario entre el Comercio Afiliado y el
                  Usuario, por lo que AEROMALL no asume ninguna responsabilidad
                  de devolución sobre los mismos. Para tal fin, el paquete que
                  sea entregado al Usuario contendrá la información de contacto
                  del Comercio Afiliado.
                  <br />
                  <br />
                  La devolución sólo aplicará en casos de defecto, o si hubiere
                  error en lo enviado en cuanto a talla, color, entre otras
                  posibles características del producto; debiendo comprobarse
                  esto último a través del pedido original. En caso de error en
                  el producto enviado, el producto deberá ser devuelto sin haber
                  sido usado, junto con sus viñetas y etiquetas adheridas y el
                  material de envoltorio, y cumplir con cualquier otra política
                  de devolución que tenga el Comercio que lo vendió, para que
                  sea cambiado por dicho Comercio directamente al Usuario.
                  <br />
                  <br />
                  Si la devolución obedeciera a defecto o error en el producto
                  enviado y el Usuario no aceptara que se le realice un cambio,
                  o si la devolución se debiera a otras razones ajenas al
                  Comercio que lo vendió, el Usuario acepta que deberá reconocer
                  los correspondientes gastos administrativos que le sean
                  indicados, en su momento, por dicho Comercio, en base a las
                  políticas que tenga este último; y que no recibirá ningún
                  reembolso ni por el costo de envío, ni por las comisiones
                  correspondientes al sistema de cobro.
                </p>
              </div>
              <div className="col-md-12">
                <h6>GARANTÍA.</h6>
                <p>
                  La garantía por defecto del producto adquirido deberá ser
                  exigida, en caso de ser aplicable, directamente por el Usuario
                  al Comercio que lo vendió, según las políticas de este último
                  y que apliquen al producto, utilizando la información de
                  contacto que señale dicho Comercio en el paquete enviado. Como
                  se ha establecido, AEROMALL es un mero intermediario entre el
                  Usuario y los Comercios Afiliados a AEROMALL, por lo que
                  AEROMALL no será responsable de ningún tipo de garantía de
                  productos de terceros; salvo por aquellos productos
                  comercializados directamente por AEROMALL.
                </p>
              </div>
              <div className="col-md-12">
                <h6>CONFIDENCIALIDAD.</h6>
                <p>
                  La información del producto que el Usuario adquiera será
                  tratada con total confidencialidad en todo momento.
                  <br />
                  <br />
                  Asimismo, AEROMALL garantiza a todo Usuario registrado en su
                  plataforma, la absoluta seguridad y confidencialidad de su
                  información personal, la cual incluye pero no se limita a
                  nombre, dirección, número telefónico, dirección de correo
                  electrónico e historiales de compra; y que no será compartida
                  con ninguna otra entidad más que con el Comercio Afiliado que
                  vende el producto y con el proveedor de servicio de entrega, a
                  menos que sea con autorización expresa del Usuario o por
                  requerimiento de autoridad.
                  <br />
                  <br />
                  Al utilizarse el sistema de pago, AEROMALL no almacena en su
                  sistema ninguna información relacionada a tarjetas de crédito
                  o débito del Usuario.
                  <br />
                  <br />
                  AEROMALL nunca solicitará información personal, o de medios de
                  pago, a través de correo electrónico. En caso de recibir algún
                  tipo de comunicación al respecto, el Usuario deberá hacerlo de
                  conocimiento inmediato de AEROMALL para que se tomen las
                  medidas de seguridad necesarias.
                  <br />
                  <br />
                  El Usuario podrá en cualquier momento cerrar la cuenta creada
                  en la plataforma de AEROMALL, sin costo alguno, para no hacer
                  usos futuros de la misma. Cualquier orden de compra previa al
                  cierre de la cuenta, no se deberá entender que ha sido
                  cancelada, debiendo seguir su curso normal hasta que el
                  producto sea entregado al Usuario.
                </p>
              </div>
              <div className="col-md-12">
                <h6>UTILIZACIÓN DE LENGUAJE APROPIADO.</h6>
                <p>
                  Tanto AEROMALL como el Usuario mantendrán la cordialidad en
                  toda comunicación. AEROMALL se reserva el derecho de bloquear
                  de su plataforma a cualquier Usuario que utilice lenguaje
                  ofensivo para AEROMALL, sus Comercios Afiliados y los demás
                  Usuarios de la plataforma
                </p>
              </div>
              <div className="col-md-12">
                <h6>LEGISLACIÓN APLICABLE.</h6>
                <p>
                  Estos términos y condiciones se rigen exclusivamente por las
                  leyes de la República de El Salvador.
                </p>
              </div>
              <div className="col-md-12">
                <h6>ACEPTACIÓN.</h6>
                <p>
                  Al dar “ACEPTAR” a los presentes términos y condiciones se
                  entiende que el Usuario los ha leído y entendido;
                  constituyéndose así un acuerdo legal entre AEROMALL y el
                  Usuario.
                </p>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default TerminosCondiciones
